const setChannel = (state, payload) => {
  state.channel = payload
}

// Canal do usuário — usado pelo export de relatório gerencial, que consolida N
// unidades e por isso não pertence a nenhuma clínica (impl-07 §4).
const setUserChannel = (state, payload) => {
  state.userChannel = payload
}

export default {
  setChannel,
  setUserChannel
}
